import script from "./graph.vue?vue&type=script&setup=true&lang=js"
export * from "./graph.vue?vue&type=script&setup=true&lang=js"

import "./graph.vue?vue&type=style&index=0&id=b92f16d0&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b92f16d0"]])

export default __exports__